module.exports = __webpack_public_path__ + "img/product_104.9d6664f.webp";